<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="marketplace_code"
                                       label="Marketplace Code"
                                       size="3"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.marketplace_code" />

                        <FormInputText fieldName="action"
                                       label="Action"
                                       size="3"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.action" />

                        <FormInputText fieldName="identity"
                                       label="Identity"
                                       size="3"
                                       :validation="['required']"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.identity" />

                        <FormInputText fieldName="status"
                                       label="Status"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.status" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="seller_id"
                                    label="Seller"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.sellers"
                                    :filter="(event) => onFilter(event, 'sellers')"
                                    v-model:field="crud.seller_id" />

                        <FormInputText fieldName="message"
                                       label="Message"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.message" />

                        <FormStaticText label="Created at"
                                        size="4"
                                        labelClass="static-text-label"
                                        class="static-text-content"
                                        :content="crud.created_at" />
                    </div>
                    <div class="grid">
                        <FormTextarea fieldName="details"
                                      label="Details"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.details" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from "@pages/Helper/crud_utils.js";
import FormInputText from "@crud/FormInputText.vue";
import FormButtons from "@crud/FormButtons.vue";
import FormStaticText from "@crud/FormStaticText.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormTextarea from "@crud/FormTextarea.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import { __ } from "@pages/Helper/utils.js";
import { onFilterService } from "@pages/Helper/crud_utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);

const options = ["sellers"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref({});

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
});

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading);
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
